'use client';

import { commonFetch, CommonFetchResponse, createCommonDefaultPagedData } from '@/utils/common-fetch';
import { PagedListOfStoreCreditInfo, StoreCreditInfo } from '@cinemark/profile-api-client';

class StoreCreditApiService {
  private readonly storeCreditsUrl = '/papi/profiles/me/store-credits';

  async getStoreCredits(): Promise<CommonFetchResponse<PagedListOfStoreCreditInfo>> {
    const response = await commonFetch<PagedListOfStoreCreditInfo>(this.storeCreditsUrl);

    if (!response) {
      return createCommonDefaultPagedData<StoreCreditInfo>();
    }

    return response;
  }
}

export const storeCreditApiService = new StoreCreditApiService();
